import React from 'react';

// Flat outline icon set (24x24 viewBox, stroke = currentColor).
// Usage: <Icon name="search" size={16} />
const PATHS = {
  search: <><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>,
  key: <><circle cx="8" cy="15" r="4" /><path d="m10.9 12.1 9.1-9.1M15 4l3 3M18 7l2 2" /></>,
  lock: <><rect x="4" y="11" width="16" height="9" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></>,
  unlock: <><rect x="4" y="11" width="16" height="9" rx="2" /><path d="M8 11V7a4 4 0 0 1 7.8-1.3" /></>,
  card: <><rect x="2" y="5" width="20" height="14" rx="2" /><path d="M2 10h20" /></>,
  clipboard: <><rect x="6" y="4" width="12" height="17" rx="2" /><path d="M9 4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2M9.5 10h5M9.5 14h5" /></>,
  building: <><rect x="4" y="3" width="16" height="18" rx="1" /><path d="M9 7h1.5M13.5 7H15M9 11h1.5M13.5 11H15M9 15h1.5M13.5 15H15M10 21v-3h4v3" /></>,
  store: <><path d="M4 9 5.5 4h13L20 9M4 9v11h16V9M4 9h16M9 20v-6h6v6" /></>,
  plus: <path d="M12 5v14M5 12h14" />,
  file: <><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5M9 13h6M9 17h6" /></>,
  users: <><circle cx="9" cy="8" r="3.5" /><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6M16 4.6a3.5 3.5 0 0 1 0 6.8M17.5 14.2c2 .8 3.5 2.6 3.5 5.8" /></>,
  user: <><circle cx="12" cy="8" r="4" /><path d="M5 20c0-3.9 3.1-7 7-7s7 3.1 7 7" /></>,
  chart: <><path d="M4 4v16h16" /><path d="M8 16v-5M12 16V8M16 16v-3" /></>,
  plug: <><path d="M9 3v5M15 3v5M6 8h12v3a6 6 0 0 1-12 0zM12 17v4" /></>,
  shield: <><path d="M12 3 5 6v5c0 4.5 3 8.4 7 10 4-1.6 7-5.5 7-10V6z" /></>,
  image: <><rect x="3" y="5" width="18" height="14" rx="2" /><circle cx="8.5" cy="10" r="1.5" /><path d="m21 16-4.5-4.5L9 19" /></>,
  megaphone: <><path d="M3 11v3l3 .5V20h3v-5l9 3V4L6 8.5H4a1 1 0 0 0-1 1z" /></>,
  message: <path d="M21 12a8 8 0 0 1-8 8H4l2.3-2.9A8 8 0 1 1 21 12z" />,
  refresh: <><path d="M20 8A8.5 8.5 0 0 0 5 7l-1.5 2M4 16a8.5 8.5 0 0 0 15 1l1.5-2" /><path d="M3.5 4v5h5M20.5 20v-5h-5" /></>,
  bag: <><path d="M6 8h12l1 13H5zM9 8V6a3 3 0 0 1 6 0v2" /></>,
  logout: <><path d="M14 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8" /><path d="m17 8 4 4-4 4M21 12H9" /></>,
  download: <><path d="M12 3v11M7 10l5 5 5-5" /><path d="M4 19h16" /></>,
  upload: <><path d="M12 15V4M7 8l5-5 5 5" /><path d="M4 19h16" /></>,
  trash: <><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6 7l1 13h10l1-13" /><path d="M10 11v5M14 11v5" /></>,
  clock: <><circle cx="12" cy="12" r="8.5" /><path d="M12 7v5l3.5 2" /></>,
  calendar: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18M8 3v4M16 3v4" /></>,
  check: <path d="m5 13 4 4L19 7" />,
  x: <path d="M6 6l12 12M18 6 6 18" />,
  alert: <><path d="M12 4 2.5 20h19z" /><path d="M12 10v4M12 17.2v.3" /></>,
  info: <><circle cx="12" cy="12" r="8.5" /><path d="M12 11v5M12 7.5v.3" /></>,
  mail: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m4 7 8 6 8-6" /></>,
  settings: <><circle cx="12" cy="12" r="3" /><path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1" /></>,
  save: <><path d="M5 3h11l5 5v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" /><path d="M8 3v5h7V3M7 21v-7h10v7" /></>,
  edit: <path d="M4 20h4L20 8a2.8 2.8 0 1 0-4-4L4 16v4zM13.5 6.5l4 4" />,
  eye: <><path d="M2 12s3.5-6.5 10-6.5S22 12 22 12s-3.5 6.5-10 6.5S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></>,
  globe: <><circle cx="12" cy="12" r="8.5" /><path d="M3.5 12h17M12 3.5c2.5 2.3 3.8 5.2 3.8 8.5s-1.3 6.2-3.8 8.5c-2.5-2.3-3.8-5.2-3.8-8.5s1.3-6.2 3.8-8.5z" /></>,
  package: <><path d="m12 3 8 4.5v9L12 21l-8-4.5v-9z" /><path d="M4 7.5l8 4.5 8-4.5M12 12v9" /></>,
  link: <><path d="M9.5 14.5 14.5 9.5" /><path d="M13 6.5 15 4.5a3.5 3.5 0 0 1 5 5l-2 2M11 17.5l-2 2a3.5 3.5 0 0 1-5-5l2-2" /></>,
  coins: <><ellipse cx="12" cy="6" rx="7" ry="3" /><path d="M5 6v6c0 1.7 3.1 3 7 3s7-1.3 7-3V6M5 12v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6" /></>,
  bell: <><path d="M18 9a6 6 0 1 0-12 0c0 6-2 7-2 7h16s-2-1-2-7" /><path d="M10.5 20a1.7 1.7 0 0 0 3 0" /></>,
  palette: <><path d="M12 3a9 9 0 1 0 0 18c1.4 0 2-.8 2-1.8 0-.9-.6-1.4-.6-2.2 0-1 .8-1.8 2-1.8H17a4.5 4.5 0 0 0 4.5-4.5C21.5 6.5 17.2 3 12 3z" /><path d="M7.5 11.5v.3M10.5 7.5v.3M15 7.5v.3" /></>,
  play: <path d="M7 5v14l12-7z" />,
  pause: <path d="M8 5v14M16 5v14" />,
  swap: <><path d="M4 8h13M14 4.5 17.5 8 14 11.5" /><path d="M20 16H7M10 12.5 6.5 16l3.5 3.5" /></>,
  cart: <><circle cx="9" cy="20" r="1.4" /><circle cx="17" cy="20" r="1.4" /><path d="M3 4h2.5l2.3 11.5h9.7L20 8H7" /></>,
  history: <><path d="M4 5v5h5" /><path d="M4.5 10a8 8 0 1 1 1.5 6" /><path d="M12 8v4l3 2" /></>,
  book: <><path d="M5 4h11a2 2 0 0 1 2 2v14H7a2 2 0 0 1-2-2z" /><path d="M5 17.5A2.5 2.5 0 0 1 7.5 15H18M8.5 8h6" /></>,
  bug: <><circle cx="12" cy="13" r="5" /><path d="M12 8V6M9 3.5 10.5 6M15 3.5 13.5 6M4 13h3M17 13h3M5.5 8.5 8 10M18.5 8.5 16 10M5.5 18.5 8 16.5M18.5 18.5 16 16.5M12 18v-5" /></>,
  video: <><rect x="3" y="6" width="13" height="12" rx="2" /><path d="m16 10 5-3v10l-5-3" /></>,
  send: <path d="M21 3 10 14M21 3l-7 18-4-7-7-4z" />,
  wrench: <path d="M14.5 6.5a4 4 0 0 0 5 5L14 17a4 4 0 0 1-5-5l5.5-5.5zM9 12 4 17a2.1 2.1 0 0 0 3 3l5-5" />,
  dot: <circle cx="12" cy="12" r="5" fill="currentColor" stroke="none" />,
  bolt: <path d="M13 2 4.5 13.5H11L10 22l8.5-11.5H13z" />,
  sun: <><circle cx="12" cy="12" r="4" /><path d="M12 2.5V5M12 19v2.5M2.5 12H5M19 12h2.5M5.3 5.3 7 7M17 17l1.7 1.7M18.7 5.3 17 7M7 17l-1.7 1.7" /></>,
  moon: <path d="M20 13.5A8 8 0 0 1 10.5 4 8 8 0 1 0 20 13.5z" />,
};

export function Icon({ name, size = 18, strokeWidth = 1.8, style, className }) {
  const path = PATHS[name];
  if (!path) return null;
  return (
    <svg
      className={className}
      style={{ flexShrink: 0, verticalAlign: '-0.18em', ...style }}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {path}
    </svg>
  );
}

export default Icon;
